export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/c149c2995e67c98d8198109bf15793c7.svg";